import React from 'react';
import PropTypes from 'prop-types';

import '../css/modal-window.css';
import '../css/animations.css';

class ModalWindow extends React.Component{
  static propTypes = {
    hed: PropTypes.string,
    deck: PropTypes.element,
    button1Function: PropTypes.func,
    button1Text: PropTypes.string,
    button2Function: PropTypes.func,
    button2Text: PropTypes.string,
  };

  componentDidMount() {
    document.querySelector('body').classList.add('lock');
  }

  componentWillUnmount() {
    document.querySelector('body').classList.remove('lock');
  }

  renderButton2 = (buttonText) => {
    if (buttonText === 'View Team') {
      return <button onClick={this.props.button2Function}>{buttonText}</button>;
    } return null;
  }
  
  render() {
    return(
      <div id="modal-window__shell">
        <div id="modal-window">
          <h4 className="benton-bold">{this.props.hed}</h4>
          {this.props.deck}
          {this.renderButton2(this.props.button2Text)}
          <button onClick={() => this.props.button1Function()}>{this.props.button1Text}</button>
        </div>
      </div>
    )
  }
}

export default ModalWindow;